<template>
    <div class="release_index no-trans" v-loading="loading">
        <div class="release_banner">
            <img src="@/assets/img/index/comments_case/release_bannse.png" alt="">
        </div>
        <div class="sever_check">
            <div class="sever_check_box">
                <div class="sever_title">选择服务</div>
                <div class="sever_borders"></div>
                <div class="check_list" :role="mobile_view ? 'radiogroup' : null" aria-label="选择点评服务">
                    <div class="list_item" v-for="(item, index) in check_list" :key="index"
                        :class="{ 'mobile_service_selected': mobile_view && check_ac == index }"
                        :role="mobile_view ? 'radio' : null" :tabindex="mobile_view ? 0 : null" :aria-checked="mobile_view ? String(check_ac == index) : null"
                        @click="mobile_view && (check_ac = index)" @keydown.enter.prevent="check_ac = index" @keydown.space.prevent="check_ac = index">
                        <div class="item_title">{{ item.title }}</div>
                        <div class="item_text">
                            {{ item.text }}
                        </div>
                        <div class="item_prices">
                            <div class="prices_nums">{{ item.prices }}</div>
                            <div class="prices_text" v-if="!mobile_view || item.prices !== '面议'">元/次</div>
                        </div>
                        <div class="item_check">
                            <div class="checks" @click="check_ac = index">
                                <img src="@/assets/img/index/legal/checks_ac.png" alt=""
                                    v-if="check_ac == index">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="check_end_btns">
                    <div class="btns" @click="handle_add" :role="mobile_view ? 'button' : null" :tabindex="mobile_view ? 0 : null" @keydown.enter.prevent="handle_add">案例发布</div>
                </div>
            </div>
        </div>
        <div class="sever_text_img">
            <div class="sever_text_img_box">

                <div class="sever_title">服务简介</div>
                <div class="sever_borders"></div>
                <div class="sever_img_texts">
                    <div class="sever_imgs">
                        <img src="@/assets/img/index/legal/bg1.png" alt="">
                    </div>
                    <div class="sever_texts">
                        领取独生子女费用，首先你要等到退休之后，办好退休手续，才能到所在地社区或者是村委进行申请填表就可以了。”独生子女“的证件给弄丢了，到所在地的卫计委查“独生子女”申请表底册，复印后就可以证明了，有单位的在单位查底册复印。第一、国家公务员以及事业单位退休的人员，会在退休时将这个独生子女的奖扶政策落入到其本人的退休金当中，退休金中会增调资5%，是随着工资发放的，终身享受的。第二、对于国有企业以及一些大型的龙头企业，在退休的时候有一次性的”独生子女“的优抚金一次性补贴。如果没有发放的，可以参照下面
                    </div>
                </div>
            </div>
        </div>
        <div class="process">
            <div class="process_box">
                <div class="sever_title">服务流程</div>
                <div class="sever_borders"></div>
                <div class="process_list">
                    <div class="process_x" v-for="(item,index) in process_list" :key="index">
                        <div class="process_y" v-for="(items,indexs) in item.list" :key="indexs">
                            <div class="process_y_title">
                                {{ items.title }}
                            </div>
                            <div class="process_y_img" v-if="indexs==0&&index<(process_list.length-1)">
                                <img src="@/assets/img/index/comments_case/rights.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            check_ac: 0,
            check_list: [
                {
                    title: '初级点评',
                    text: '',
                    prices: '600',
                },
                {
                    title: '中级点评',
                    text: '',
                    prices: '5000',
                },
                {
                    title: '高级点评',
                    text: '',
                    prices: '8000',
                },
                {
                    title: '特级点评',
                    text: '',
                    prices: '面议',
                },
            ],
            process_list:[
                {
                    list:[
                        {
                            title:'阅读服务简介',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'选择服务',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'初级点评',//
                        },
                        {
                            title:'中级点评',//
                        },
                        {
                            title:'高级点评',//
                        },
                        {
                            title:'特级点评',//
                        },
                    ]
                },
                {
                    list:[
                        {
                            title:'提交资料',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'管理员审核',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'成交下单',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'提供服务',//
                        },

                    ]
                },

            ]

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_setting()
    },
    methods: {
        get_setting(){
            this.loading=true
            this.$api("setting", {
				 
			}, "get").then((res) => {
                this.loading = false
                console.log('配置',res)
                if (res.code == 1) {
                    this.check_list= [
                        {
                            title: '初级点评',
                            text: res.data.levelTxt1,
                            prices: res.data.level1,
                            prices_end: res.data.level1,
                        },
                        {
                            title: '中级点评',
                            text: res.data.levelTxt2,  
                            prices: res.data.level2,
                            prices_end: res.data.level2,

                        },
                        {
                            title: '高级点评',
                            text: res.data.levelTxt3,  
                            prices: res.data.level3,
                            prices_end: res.data.level3,

                        },
                        {
                            title: '特级点评',
                            text: res.data.levelTxt4,  
                            prices: '面议',
                            prices_end: res.data.level4,
                        },
                    ]
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_home() {
            this.$router.push({
                path: '/home',
            })
        },
        handle_add(){
            this.$router.push({
                path: '/release_add',
                query:{
                    type:this.check_ac+1,
                    price:this.check_list[this.check_ac].prices_end
                }
            }) 
        },
    },

}
</script>
<style scoped lang="less">
.release_index {
    .release_banner {
        width: 100%;
        height: 480px;

        img {
            width: 100%;
            height: 480px;
        }
    }

    .sever_check {
        // height: 830px;
        background: #F9FBFF;
        padding-bottom: 80px;

        .sever_check_box {
            width: 1440px;
            margin: auto;
            // height: 830px;
            padding-top: 80px;

            .sever_title {
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 36px;
                color: #333333;
            }

            .sever_borders {
                width: 80px;
                height: 5px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
                margin: auto;
                margin-top: 24px;
            }

            .check_list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 80px;

                .list_item {
                    width: 315px;
                    height: 356px;
                    // background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    box-shadow: 1px 1px 30px #cdd3d1;
                    padding: 28px;

                    .item_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        text-align: center;
                        padding-top: 30px;
                    }

                    .item_text {
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        text-align: center;
                        line-height: 36px;
                        height: 150px;
                    }

                    .item_prices {
                        display: flex;
                        align-items: end;
                        justify-content: center;

                        .prices_nums {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #377CFD;
                        }

                        .prices_text {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                        }
                    }

                    .item_check {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 20px;

                        .checks {
                            width: 32px;
                            height: 32px;
                            background: #FFFFFF;
                            border: 1px solid #D7D7D7;
                            border-radius: 50%;
                            cursor: pointer;

                            img {
                                width: 32px;
                                // height: 32px;
                            }
                        }
                    }

                }
            }

            .check_end_btns {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 80px;
                margin-bottom: 80px;

                .btns {
                    width: 220px;
                    height: 50px;
                    background: #377CFD;
                    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                    border-radius: 4px 4px 4px 4px;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #FFFFFF;

                }
            }


        }


    }

    .sever_text_img {
        padding-bottom: 80px;

        .sever_title {
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #333333;
        }

        .sever_borders {
            width: 80px;
            height: 5px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
            margin: auto;
            margin-top: 24px;
        }

        .sever_text_img_box {
            width: 1440px;
            margin: auto;
            // height: 830px;
            padding-top: 80px;

            .sever_img_texts {
                display: flex;
                align-items: top;
                padding-top: 64px;

                .sever_imgs {
                    flex-shrink: 0;
                    width: 560px;
                    height: 333px;

                    img {
                        width: 560px;
                        height: 333px;
                    }
                }

                .sever_texts {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    padding-left: 40px;
                }
            }
        }

    }
    .process{
        width: 100%;
        height: 750px;
        background-image: url('../../../assets/img/index/comments_case/bg1.png');
        background-size: 100%;

        .process_box{
            width: 1440px;
            margin: auto;
            padding-top: 80px;
            .sever_title {
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 36px;
                color: #333333;
            }

            .sever_borders {
                width: 80px;
                height: 5px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
                margin: auto;
                margin-top: 24px;
            }
            .process_list{
                display: flex;
                align-items: top;
                .process_x{
                    padding-top: 80px;
                    .process_y{
                        display: flex;
                        align-items: center;
                        margin-right: 24px;
                        margin-bottom: 21px;
                        .process_y_title{
                            flex-shrink: 0;
                            width: 158px;
                            height: 92px;
                            background: #FFFFFF;
                            box-shadow: 0px 3px 20px 1px rgba(0,0,0,0.06);
                            border-radius: 20px 20px 20px 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #666666;
                        }
                        .process_y_img{
                            margin-left: 24px;
                            flex-shrink: 0;
                            width: 9px;
                            height: 10px;

                            img{
                                vertical-align: middle; 
                                width: 9px;
                                height: 10px;
                            }
                        }
                        

                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .release_index.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .release_index.no-trans .release_banner {
        min-height: 0;
        height: auto;
    }
    .release_index.no-trans .release_banner img {
        min-height: 0;
        height: auto;
    }
    .release_index.no-trans .sever_check {
        padding-bottom: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .sever_title {
        font-size: 24px;
    }
    .release_index.no-trans .sever_check .sever_check_box .sever_borders {
        width: 80px;
        height: 5px;
        border-radius: 3px 3px 3px 3px;
        margin: auto;
        margin-top: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        max-width: 100%;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        padding: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_title {
        font-size: 20px;
        padding-top: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 36px;
        min-height: 0;
        height: auto;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_prices {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_prices .prices_nums {
        font-size: 24px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_prices .prices_text {
        font-size: 14px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_check {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_check .checks {
        width: 32px;
        height: 32px;
        border-radius: 50%;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_list .list_item .item_check .checks img {
        width: 32px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_end_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        margin-bottom: 16px;
    }
    .release_index.no-trans .sever_check .sever_check_box .check_end_btns .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 20px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .release_index.no-trans .sever_text_img {
        padding-bottom: 16px;
    }
    .release_index.no-trans .sever_text_img .sever_title {
        font-size: 24px;
    }
    .release_index.no-trans .sever_text_img .sever_borders {
        width: 80px;
        height: 5px;
        border-radius: 3px 3px 3px 3px;
        margin: auto;
        margin-top: 16px;
    }
    .release_index.no-trans .sever_text_img .sever_text_img_box {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        margin: auto;
        padding-top: 16px;
    }
    .release_index.no-trans .sever_text_img .sever_text_img_box .sever_img_texts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .release_index.no-trans .sever_text_img .sever_text_img_box .sever_img_texts .sever_imgs {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .release_index.no-trans .sever_text_img .sever_text_img_box .sever_img_texts .sever_imgs img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .release_index.no-trans .sever_text_img .sever_text_img_box .sever_img_texts .sever_texts {
        font-size: 18px;
        padding-left: 16px;
    }
    .release_index.no-trans .process {
        min-height: 0;
        height: auto;
    }
    .release_index.no-trans .process .process_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 16px;
    }
    .release_index.no-trans .process .process_box .sever_title {
        font-size: 24px;
    }
    .release_index.no-trans .process .process_box .sever_borders {
        width: 80px;
        height: 5px;
        border-radius: 3px 3px 3px 3px;
        margin: auto;
        margin-top: 16px;
    }
    .release_index.no-trans .process .process_box .process_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .release_index.no-trans .process .process_box .process_list .process_x {
        padding-top: 16px;
    }
    .release_index.no-trans .process .process_box .process_list .process_x .process_y {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 16px;
        margin-bottom: 16px;
    }
    .release_index.no-trans .process .process_box .process_list .process_x .process_y .process_y_title {
        width: 158px;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 16px;
    }
    .release_index.no-trans .process .process_box .process_list .process_x .process_y .process_y_img {
        margin-left: 16px;
        width: 9px;
        height: 10px;
    }
    .release_index.no-trans .process .process_box .process_list .process_x .process_y .process_y_img img {
        width: 9px;
        height: 10px;
    }
}
@media (max-width: 1024px) {
    .release_index.no-trans {
        background: #fff;
        .release_banner { height: auto; }
        .release_banner img { display: block; width: 100%; height: auto; }
        .sever_check { padding: 24px 16px; background: #fff; }
        .sever_check .sever_check_box,
        .sever_text_img .sever_text_img_box,
        .process .process_box { width: 100%; padding: 0; }
        .sever_check .sever_check_box .sever_title,
        .sever_text_img .sever_text_img_box .sever_title,
        .process .process_box .sever_title { text-align: left; font-size: 20px; line-height: 30px; color: #303846; }
        .sever_check .sever_borders, .sever_text_img .sever_borders, .process .process_box .sever_borders { display: none; }
        .sever_check .sever_check_box {
            .check_list {
                display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: stretch; gap: 12px; padding-top: 16px;
                .list_item {
                    position: relative; display: flex; flex-direction: column; width: 100%; height: auto; min-height: 172px;
                    margin: 0; padding: 16px 12px; border: 1px solid #e0e7f0; border-radius: 6px; background: #fff; box-shadow: none; cursor: pointer;
                    .item_title { padding: 0 22px 0 0; text-align: left; font-size: 17px; line-height: 26px; color: #303846; }
                    .item_text { flex: 1; height: auto; min-height: 0; margin: 0; padding-top: 8px; text-align: left; font-size: 13px; line-height: 23px; color: #748092; overflow-wrap: anywhere; }
                    .item_prices { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: flex-start; gap: 3px; padding-top: 14px; margin: 0; }
                    .item_prices .prices_nums { font-size: 23px; line-height: 32px; color: #d95359; overflow-wrap: anywhere; }
                    .item_prices .prices_text { font-size: 13px; line-height: 22px; color: #87909d; }
                    .item_check { position: absolute; top: 15px; right: 10px; padding: 0; height: 22px; }
                    .item_check .checks { display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; border: 1px solid #b9c8dd; border-radius: 50%; background: #fff; }
                    .item_check .checks img { width: 18px; height: 18px; object-fit: contain; }
                    &.mobile_service_selected { border-color: #377cfd; background: #f3f7ff; box-shadow: inset 0 0 0 1px #377cfd; }
                    &.mobile_service_selected .item_title { color: #2468e8; }
                    &:focus-visible { outline: 2px solid #377cfd; outline-offset: 2px; }
                }
            }
            .check_end_btns { padding-top: 20px; }
            .check_end_btns .btns { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 48px; height: auto; padding: 12px; border-radius: 4px; font-size: 16px; line-height: 24px; }
        }
        .sever_text_img {
            height: auto; padding: 24px 16px; background: #f5f7fb;
            .sever_text_img_box .sever_img_texts { display: block; padding-top: 12px; }
            .sever_text_img_box .sever_img_texts .sever_imgs { display: none; }
            .sever_text_img_box .sever_img_texts .sever_texts { padding: 0; width: 100%; font-size: 15px; line-height: 28px; color: #687587; overflow-wrap: anywhere; }
        }
        .process {
            padding: 24px 16px; background: #fff;
            .process_box .process_list {
                display: block; padding-top: 16px; counter-reset: release-step;
                .process_x {
                    box-sizing: border-box; position: relative; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; gap: 8px; padding: 0 0 20px 44px; margin: 0; min-height: 60px; counter-increment: release-step;
                    &::before { content: counter(release-step); position: absolute; top: 6px; left: 0; display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: #eaf1ff; color: #377cfd; font-size: 14px; line-height: 28px; }
                    &::after { content: ''; position: absolute; top: 38px; bottom: -2px; left: 13px; width: 2px; background: #e7edf6; }
                    &:last-child { padding-bottom: 0; }
                    &:last-child::after { display: none; }
                    .process_y { grid-column: ~"1 / -1"; display: block; min-width: 0; width: 100%; margin: 0; }
                    .process_y .process_y_title { box-sizing: border-box; display: flex; align-items: center; justify-content: flex-start; width: 100%; height: auto; min-height: 40px; padding: 6px 0; font-size: 15px; font-weight: 500; line-height: 24px; background: transparent; border: 0; border-radius: 0; box-shadow: none; color: #526074; overflow-wrap: anywhere; }
                    &:nth-child(3) .process_y { grid-column: auto; }
                    &:nth-child(3) .process_y .process_y_title { justify-content: center; padding: 8px; font-size: 14px; background: #f5f8fc; border-radius: 4px; }
                    .process_y .process_y_img { display: none; }
                }
            }
        }
    }
}
</style>
